export const ENCRYPT_GUID = 'c026002d-cda6-401e-bfad-28de214d0fba';
export const ENCRYPT_DNF_GUID = 'cf5cf348-a8d7-40d5-91ef-a600b88a395d';
export const ENCRYPT_DNRA_GUID = 'ce1584ed-3033-4a43-a76b-5aed8599329d';
// IRM current default is Do Not Forward
export const IRM_DEFAULT_GUID = ENCRYPT_GUID;
